<template>
  <div v-if="buttons.length" class="preview-action-buttons">
    <div
      class="preview-action-buttons__title"
      :data-qa="`${dataQaPrefix}-buttons-title`"
    >
      {{ $t('CampaignForm_Preview_Push_ButtonsTitle') }}
    </div>
    <div
      v-for="(btn, i) in buttons"
      :key="`${btn.label}-${btn.url || btn.deeplink || ''}`"
      class="preview-action-buttons__row"
      :data-qa="`${dataQaPrefix}-button-action-${i}`"
    >
      <span class="preview-action-buttons__label">{{ btn.label }}</span>
      <span class="preview-action-buttons__action-type">
        <template v-if="btn.url">
          {{ $t('CampaignForm_Push_DefaultAction_Url') }}
        </template>
        <template v-else-if="btn.deeplink">
          {{ $t('CampaignForm_Push_DefaultAction_Deeplink') }}
        </template>
        <template v-else>—</template>
      </span>
      <a
        v-if="isSafeHttpUrl(btn.url)"
        :href="btn.url"
        target="_blank"
        rel="noopener noreferrer"
        class="preview-action-buttons__value preview-action-buttons__link"
        :data-qa="`${dataQaPrefix}-button-action-${i}-link`"
      >
        {{ btn.url }}
      </a>
      <span
        v-else-if="btn.url || btn.deeplink"
        class="preview-action-buttons__value"
        :data-qa="`${dataQaPrefix}-button-action-${i}-value`"
      >
        {{ btn.url || btn.deeplink }}
      </span>
    </div>
  </div>
</template>

<script>
import { isSafeHttpUrl } from '@/core/helpers'

export default {
  name: 'PreviewActionButtons',
  props: {
    buttons: {
      type: Array,
      required: true
    },
    dataQaPrefix: {
      type: String,
      required: true
    }
  },
  methods: {
    isSafeHttpUrl
  }
}
</script>

<style scoped>
.preview-action-buttons__title {
  font-size: 13px;
  font-weight: 700;
  color: #303133;
  margin-top: 12px;
  margin-bottom: 8px;
}

.preview-action-buttons__row {
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding-bottom: 12px;
  word-break: break-all;
}

.preview-action-buttons__label {
  font-weight: 600;
  flex-shrink: 0;
}

.preview-action-buttons__action-type {
  flex-shrink: 0;
  color: #909399;
}

.preview-action-buttons__value {
  word-break: break-all;
  min-width: 0;
}

.preview-action-buttons__link {
  color: #409eff;
  text-decoration: none;
}

.preview-action-buttons__link:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/preview/PreviewActionButtons.vue